import styled, { css } from 'styled-components';
import { breakpoints } from '../../../theme/index';

interface HighlightsContainerProps {
  $backgroundImage: string;
}

interface ArrowButtonProps {
  direction: 'left' | 'right';
}

export const HighlightsContainer = styled.section<HighlightsContainerProps>`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url(${(props) => props.$backgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 2rem 0;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7); /* Improved overlay for contrast */
    z-index: 0;
  }
`;

export const ContentContainer = styled.div`
  position: relative;
  width: 90%;
  max-width: 1900px;
  background-color: rgba(221, 189, 169, 0.2); 
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 3rem 2rem;
  margin: 5rem auto;
  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.37);
  border: 1px solid rgba(255, 255, 255, 0.18);
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  @media (max-width: ${breakpoints.tablet}) {
    width: 95%;
    padding: 2rem 1rem;
  }
`;

export const HighlightsHeader = styled.div`
  text-align: center;
  margin-bottom: 3rem;

  .mission-heading {
    font-size: 2.5rem;
    color: #fff; /* Adjusted for contrast */
    margin-bottom: 0.5rem;
  }

  p {
    font-size: 1.2rem;
    color: #f0f0f0; 
    line-height: 1.6;
    max-width: 800px;
    margin: 0 auto;
  }

  @media (max-width: ${breakpoints.tablet}) {
    margin-bottom: 2rem;
 
    align-items: center;
    .mission-heading {
      font-size: 2rem;
    }

    p {
      font-size: 1rem;
      text-align: center;
    }
     
    
  }
`;

export const HighlightsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  width: 100%;
  justify-content: center;

  &.center-single-item {
    > :last-child {
      grid-column: 1 / -1;
      justify-self: center;
    }
  }
`;

export const SlideshowWrapper = styled.div`
  width: 100%;
  max-height: 50vh;
  display: flex;
  justify-content: center;
  padding: 2rem 0;
  z-index: 1;
`;

export const SlideshowContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 2rem;
  color: #fff;


  .slick-prev,
  .slick-next {
    z-index: 2;
  }

  img {
    width: 100%;
    max-height: 50vh;
    object-fit: cover;
    border-radius: 10px;

    @media (max-width: ${breakpoints.tablet}) {
      max-height: 40vh;
    }
  }
`;

export const Slide = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const SlideOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  justify-content: center;

  `
export const SlideContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 80%;
  transform: translate(-50%, -50%);
  align-items: center;
  text-align: center;
  color: #fff;
 

  .slide-heading {
    font-size: 3rem;
    margin-top: 7rem;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    color: #FFD700;

    @media (max-width: ${breakpoints.tablet}) {
      font-size: 2rem;
    }
  }

  p {
    font-size: 1.25rem;
    line-height: 1.5;
    color: #f0f0f0;
  }
`;

export const ArrowButton = styled.button<ArrowButtonProps>`
  position: absolute;
  top: 50%;
  ${(props) =>
    props.direction === 'left'
      ? css`
          left: 10px;
        `
      : css`
          right: 10px;
        `}
  transform: translate(0, -50%);
  background: rgba(0, 0, 0, 0.5);
  padding: 0.5rem;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }

  svg {
    color: #fff;
  }
`;
